// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  min-width: 80px;
  min-height: 35px;
}
ion-button span {
  cursor: pointer;
}

ol li {
  font-size: 14px;
  margin-bottom: 5px;
}

ion-label {
  font-size: 14px;
  font-weight: 500;
}

ion-icon {
  margin-right: 10px;
}

.file-upload {
  cursor: pointer;
  opacity: 0;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/upload-document/upload-document.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;AACR;;AAII;EACI,eAAA;EACA,kBAAA;AADR;;AAMA;EACI,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,UAAA;EACA,kBAAA;AAHJ","sourcesContent":["ion-button {\n    min-width: 80px;\n    min-height: 35px;\n\n    span{\n        cursor: pointer;\n    }\n}\n\nol{\n    li{\n        font-size: 14px;\n        margin-bottom: 5px;\n        //font-weight: 700;\n    }\n}\n\nion-label{\n    font-size: 14px;\n    font-weight: 500;\n}\n\nion-icon{\n    margin-right: 10px;\n}\n\n.file-upload {\n    cursor: pointer;\n    opacity: 0;\n    position: absolute;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
